import React from "react";
import { StatusBadge } from "@/components/ds";
import type { InboxConversation } from "@/lib/api";
import { STATUS_META, CHANNEL_META, fmtTime } from "./constants";

export function ConversationList({ items, selectedId, onSelect }: {
  items: InboxConversation[]; selectedId: string | null; onSelect: (id: string) => void;
}) {
  if (items.length === 0) {
    return <div className="p-6 text-center text-sm text-slate-400" data-testid="inbox-empty">No conversations match your filters.</div>;
  }
  return (
    <div className="divide-y divide-slate-100" data-testid="conversation-list">
      {items.map((c) => {
        const Ch = CHANNEL_META[c.channel]?.icon ?? CHANNEL_META.sms.icon;
        const sm = STATUS_META[c.status] ?? STATUS_META.open;
        const unread = c.unread_count > 0;
        const active = c.id === selectedId;
        return (
          <button key={c.id} onClick={() => onSelect(c.id)} data-testid={`conversation-item-${c.id}`}
            className={`flex w-full flex-col gap-1 px-4 py-3 text-left transition-colors ${active ? "bg-blue-50" : "hover:bg-slate-50"}`}>
            <div className="flex items-center justify-between gap-2">
              <div className="flex min-w-0 items-center gap-2">
                {unread && <span className="h-2 w-2 shrink-0 rounded-full bg-blue-600" data-testid={`unread-dot-${c.id}`} />}
                <Ch className="h-3.5 w-3.5 shrink-0 text-slate-400" />
                <span className={`truncate text-sm ${unread ? "font-semibold text-slate-900" : "font-medium text-slate-700"}`}>{c.contact_name ?? "Unknown"}</span>
              </div>
              <span className="shrink-0 text-[11px] text-slate-400">{fmtTime(c.last_message_at)}</span>
            </div>
            <p className="truncate text-xs text-slate-500">{c.last_message_preview ?? c.subject}</p>
            <div className="flex items-center gap-1.5">
              <StatusBadge tone={sm.tone}>{sm.label}</StatusBadge>
              {!c.ai_active && <StatusBadge tone="amber">AI paused</StatusBadge>}
            </div>
          </button>
        );
      })}
    </div>
  );
}
